/** Tipos de nota que o fornecedor emite para a conta a pagar (valores do enum TipoDocumentoFiscal do back). */
export enum TipoNotaFiscalContaPagar {
  Nfse = 1,
  Nfe = 3
}

export enum StatusNotaFiscalContaPagar {
  Ativa = 1,
  Cancelada = 2
}

/** O que a substituição de parcela faz com a nota fiscal da parcela substituída. */
export enum AcaoNotaFiscalSubstituicao {
  Cancelar = 1,
  Levar = 2
}

export const OPCOES_TIPO_NOTA_FISCAL_CONTA_PAGAR: { valor: TipoNotaFiscalContaPagar; texto: string }[] = [
  { valor: TipoNotaFiscalContaPagar.Nfse, texto: 'NFS-e' },
  { valor: TipoNotaFiscalContaPagar.Nfe, texto: 'NF-e' }
];

/** Nota fiscal do fornecedor, como o back devolve. */
export interface NotaFiscalContaPagar {
  notaFiscalContaAPagarId: number;
  tipoDocumentoFiscal: TipoNotaFiscalContaPagar;
  numero: string;
  serie: string | null;
  dataEmissao: string;
  status: StatusNotaFiscalContaPagar;
}

/** Parcela da conta a pagar com a nota fiscal que a cobre (GET consultar-nota-fiscal-conta-a-pagar e consultar-parcelas-nota-fiscal-conta-a-pagar). */
export interface ContaParcelaNotaFiscalContaPagar {
  contaParcelaId: number;
  contaId: number;
  descricao: string | null;
  dataVencimento: string;
  valorParcela: number;
  /** Valor antes das retenções; sem valor informado, o back devolve o próprio valor da parcela. */
  valorBruto: number;
  statusPagamento: number;
  /** A parcela aceita informar ou alterar a nota (não está cancelada nem substituída). */
  permiteEditarNotaFiscal: boolean;
  notaFiscal: NotaFiscalContaPagar | null;
}

/** Corpo para informar ou alterar a nota de uma parcela. */
export interface NotaFiscalContaPagarParcelaRequest {
  tipoDocumentoFiscal: TipoNotaFiscalContaPagar;
  numero: string;
  serie: string | null;
  dataEmissao: string;
  valorBruto: number;
}

/** Corpo para informar uma nota para a conta toda. */
export interface NotaFiscalContaPagarContaRequest {
  tipoDocumentoFiscal: TipoNotaFiscalContaPagar;
  numero: string;
  serie: string | null;
  dataEmissao: string;
  parcelas: { contaParcelaId: number; valorBruto: number }[];
}
